import React from 'react';
import styles from './WizardSteps.module.scss';
function WizardSteps({ navigation, children }) {
    return (React.createElement("div", { className: styles.wrap },
        React.createElement("div", { className: styles.navigation }, navigation),
        React.createElement("div", { className: styles.main }, children)));
}
export default WizardSteps;
